export default "__VITE_ASSET__C4LWwB8G__"